<template>
  <x-page :loading="loading" classical title="新春年货节">
    <template v-if="!loading">
      <!-- 头图 -->
      <div :class="_.headImage">
        <div
          :class="_.rule"
          @click="goRule(homeData.跳转配置 && homeData.跳转配置[0].targetUrl)"
        >
          活动规则
        </div>
      </div>

      <div :class="_.main">
        <!-- 容器 -->
        <div :class="_.container">
          <!-- 优惠展示 -->
          <div :class="_.discount">
            <div :class="_.time">活动时间：2025年1月9日—2025年1月23日</div>

            <div
              v-if="homeData.券配置"
              :class="_.quan"
              :style="{
                opacity:
                  homeData.券配置 &&
                  homeData.券配置[1] &&
                  homeData.券配置[1].title.split('：')[1] === '已用光'
                    ? 0.5
                    : 1,
                backgroundImage: `url(${
                  homeData.券配置[1] && homeData.券配置[1].icon
                })`,
              }"
            >
              <div :class="_.left">
                <span>8</span>
                折
              </div>
              <div :class="_.right">
                <p>满300可用</p>
                <p>折扣优惠每次200元封顶，活动期间享受2次优惠</p>
              </div>
            </div>
            <!-- <div :class="_.go" @click="goMore"></div> -->
            <img
              :class="_.go"
              :src="
                (homeData.券配置 &&
                  homeData.券配置[0] &&
                  homeData.券配置[0].icon) ||
                require('./images/查看更多.png')
              "
              alt=""
              @click="goMore"
            />
            <!-- <div :class="_.tips">
              <img src="./images/云闪付.png" alt="" />
              <span>选择云闪付支付享立减</span>
            </div> -->
          </div>

          <!-- 推荐商品 -->
          <div
            v-if="homeData.多多爆款推荐 && homeData.多多爆款推荐.length"
            :class="_.recommend"
          >
            <div :class="_.con">
              <div :class="_.goodsList">
                <div
                  v-for="item in homeData.多多爆款推荐.slice(0, 9)"
                  :key="item.id"
                  :class="_.good"
                  @click="$handleResourceClick(item, item.title)"
                >
                  <img v-lazy="item.icon" :src="item.icon" alt="" />
                  <div :class="_.text">
                    <p class="van-ellipsis">{{ item.title }}</p>
                    <p>
                      <span><font>￥</font>{{ item.discountAmt }}</span>
                      <!-- <del v-if="false">￥{{ item.amt }}</del> -->
                    </p>
                  </div>
                </div>
              </div>

              <div :class="_.more" @click="goMore">查看更多</div>
            </div>
          </div>

          <div :class="_.activity">
            <div :class="[_.sec, _.sec1]" @click="goBlind">
              <div :class="_.title">新春开盲盒</div>
              <div :class="_.desc">随机获得最高199元膨胀产品</div>
              <div :class="_.btn">开好运</div>
            </div>
            <div :class="[_.sec, _.sec2]" @click="goDraw">
              <div :class="_.title">惊喜大转盘</div>
              <div :class="_.desc">参与活动赢取抽奖机会</div>
              <div :class="_.btn">去抽奖</div>
            </div>
          </div>

          <img :class="_.hd" src="./images/多彩贵州线下攻略.png" alt="" />

          <div :class="_.strategy">
            <img :class="_.map" src="./images/map.png" alt="" />
            <div :class="_.thing">
              <div :class="_.label">线下会展时间</div>
              <div :class="_.value">
                <img src="./images/icon_time.png" alt="" />2025年1月9日 ~
                2025年1月23日
              </div>
            </div>
            <div :class="_.thing">
              <div :class="_.label">线下活动地址</div>
              <div :class="_.value">
                <img
                  src="./images/icon_addr.png"
                  alt=""
                />贵阳市南明区龙洞堡老里坡1号
              </div>
            </div>

            <img
              :class="_.go"
              src="./images/到这里.png"
              alt=""
              @click="goMap"
            />
          </div>

          <!-- 更多商品 -->
          <div v-if="!isEmpty" :class="_.waterfall">
            <div :class="_.title">
              <img :class="_.left" src="./images/更多好物_左.png" alt="" />
              <div>更多好物</div>
              <img src="./images/更多好物_右.png" alt="" />
            </div>

            <x-waterfall :load="handleLoad" no-complete-tips>
              <template #default="{ data }">
                <x-masonry :class="_.list" :col-count="2" :gap="12">
                  <div
                    v-for="(item, index) in data"
                    :key="index"
                    v-track="{
                      name: '多多商城_2025新春年货活动_更多好物',
                      newId: 'shou_ye_re_men_tui_jian',
                      extra: {
                        tui_jian_lei_xing: '更多商品',
                        chan_pin_wei_zhi: 4,
                        shang_pin_id: item.id || '',
                        track_code: 'f0db3c64c09d45de986a422fd5c908f8',
                      },
                    }"
                    :class="_.item"
                    @click="$handleResourceClick(item, '首页更多商品')"
                  >
                    <x-square>
                      <img :src="item.icon" :class="_.cover" />
                    </x-square>
                    <div :class="_.content">
                      <div :class="_.name">
                        {{ item.title }}
                      </div>
                      <div v-if="item.tags && item.tags.length" :class="_.tags">
                        <div v-for="tag in item.tags" :key="tag" :class="_.tag">
                          {{ tag }}
                        </div>
                      </div>
                      <div :class="_.extra">
                        <div :class="_.price">
                          <span>￥</span>{{ item.discountAmt }}
                        </div>
                        <div :class="_.sales">销量 {{ item.sales }}</div>
                      </div>
                    </div>
                  </div>
                </x-masonry>
              </template>
            </x-waterfall>
          </div>
        </div>
      </div>
    </template>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import { apiPageConfigDecorateSearchData } from '@/api'
  import { dcb } from '@dcb/jssdk'
  import { fromPairs } from 'vtils'
  import { globalModel } from '@/model'
  // import { navigateTo } from '@/router'
  import { openMap } from '@/utils'
  import { prepareData, pxToRem, requiredDeep } from '@/utils'
  import { Toast } from 'vant'
  // import { Toast } from 'vant'

  export default Vue.extend({
    props: {
      pageHdHeight: {
        type: Number,
        required: true,
      },
    },

    data: () => ({
      // 页面级加载状态
      loading: true,
      isEmpty: false,

      // 首页数据
      homeData: {},

      // 是否内嵌
      isEmbed: globalModel.state.isEmbed,
    }),

    activated() {
      this.prepareData()
    },

    methods: {
      pxToRem: pxToRem,

      // 准备数据
      async prepareData() {
        const { homeData } = await prepareData({
          homeData: Promise.all(
            [
              '多多商城_2025新春年货活动_券配置',
              '多多商城_2025新春年货活动_多多爆款推荐',
              '多多商城_2025新春年货活动_跳转配置',
            ].map(async id => [
              id.replace('多多商城_2025新春年货活动_', '').replace(/-/g, '_'),
              await apiPageConfigDecorateSearchData(
                {
                  id: id,
                  pageIndex: 1,
                  pageSize: 100,
                },
                {
                  name: id,
                },
              )
                .then(requiredDeep)
                .then(res => res.list),
            ]),
          ).then(res => fromPairs(res)),
        })

        this.homeData = homeData

        console.log(homeData)

        this.loading = false
      },

      async handleLoad({ pageNumber }) {
        const res = await apiPageConfigDecorateSearchData(
          {
            id: '多多商城_2025新春年货活动_更多好物',
            pageIndex: pageNumber,
            pageSize: 10,
          },
          {
            name: '多多商城_2025新春年货活动_更多好物',
          },
        )
        if (pageNumber === 1 && !res.list?.length) {
          this.isEmpty = true
        }
        return res
      },
      async goMap() {
        const env = await dcb.getEnv()
        if (env.wechat) {
          dcb.navigateTo({
            url: 'http://api.map.baidu.com/place/search?query=贵阳市南明区龙洞堡老里坡1号&location=26.529697,106.789156&radius=1000&region=贵阳&output=html&src=webapp.baidu.openAPIdemo',
          })
        } else {
          openMap({
            name: '贵阳市南明区龙洞堡老里坡1号',
            latitude: '26.529697',
            longitude: '106.789156',
          })
        }
      },
      goMore() {
        dcb.navigateTo({
          url: 'https://h5p-gw.gogpay.cn/app/duoduo-mall/#/diy/page/index?isLogin=true&isAuth=true&isFull=true&type=preview&id=8aaa92eb93cf6a52019448c1e79a46e2&refUserGroupId=100000&rf=d3537648',
        })
      },
      goRule(url) {
        dcb.navigateTo({ url })
      },
      goBlind() {
        Toast('活动已结束!')
        // const activityId =
        //   this.homeData['跳转配置'] && this.homeData['跳转配置'][2].targetUrl
        // navigateTo('BoxIndex_2025', {
        //   id: activityId,
        // })
      },
      goDraw() {
        const activityId =
          this.homeData['跳转配置'] && this.homeData['跳转配置'][1].targetUrl
        const isProd = process.env.VUE_APP_RUN_ENV === 'production'
        dcb.navigateTo({
          url: `https://h5p-gw.${
            isProd ? 'gogpay' : 'duotest'
          }.cn/app/duoduo-activity/#/lottery/index_2025?activityId=${activityId}&isFull=true&isAuth=true&isLogin=true`,
        })
      },
    },
  })
</script>

<style lang="scss" module>
  .headImage {
    position: relative;
    width: 100%;
    height: 457px;
    background-image: url('./images/头图.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    .rule {
      position: absolute;
      right: 0;
      bottom: 160px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #ffffff;
      line-height: 20px;
      text-align: center;
      font-style: normal;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #ffffff;
      line-height: 20px;
      text-align: center;
      font-style: normal;
      background: rgba(0, 0, 0, 0.6);
      border-radius: 100px 0px 0px 100px;
      padding: 5px 12px;
    }
  }

  .main {
    position: relative;
    // margin-top: calc(var(--page-header-height) - 75px + 12px);
    font-size: 0;

    .container {
      background: url('./images/通用背景.png');
      padding: 12px;

      .discount {
        margin-top: -90px;
        box-sizing: border-box;
        background: url('./images/优惠背景.png');
        background-size: 100% 100%;
        height: 240px;
        padding: 43px 14px 14px;
        .time {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 13px;
          color: #ff2542;
          line-height: 18px;
          text-align: center;
          font-style: normal;
        }
        .quan {
          display: flex;
          align-items: center;
          margin-top: 12px;
          width: 327px;
          height: 82px;
          vertical-align: middle;
          background: url('./images/券背景.png');
          background-size: 100% 100%;
          .left {
            width: 100px;
            flex-shrink: 0;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #922d17;
            line-height: 22px;
            text-align: center;
            font-style: normal;
            span {
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 38px;
              color: #ff2542;
              line-height: 53px;
              text-align: center;
              font-style: normal;
            }
          }
          .right {
            padding-right: 35px;
            p:nth-child(1) {
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 16px;
              color: #922d17;
              line-height: 22px;
              text-align: left;
              font-style: normal;
            }
            p:nth-child(2) {
              margin-top: 2px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 12px;
              color: rgba(146, 45, 23, 0.9);
              line-height: 17px;
              text-align: left;
              font-style: normal;
            }
          }
        }
        .go {
          width: 100%;
          display: block;
          // background: url('./images/去下单.png');
          // background-size: 100% 100%;
          // height: 70px;
          margin: 0 auto;
          margin-top: 12px;
          vertical-align: middle;
        }
        .tips {
          margin-top: -3px;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 17px;
            height: 17px;
            margin-right: 4px;
          }
          span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #88574e;
            line-height: 17px;
            text-align: justify;
            font-style: normal;
          }
        }
      }

      .recommend {
        margin-top: 14px;
        height: 613px;
        background: url('./images/新春爆款推荐.png');
        background-size: 100% 100%;
        padding-top: 45px;
        box-sizing: border-box;

        .con {
          .goodsList {
            display: flex;
            flex-wrap: wrap;
            padding: 0 8px;

            .good {
              width: 106px;
              margin-right: 8px;
              margin-bottom: 8px;
              &:nth-child(3n) {
                margin-right: 0;
              }
              img {
                width: 106px;
                height: 107px;
                vertical-align: middle;
                object-fit: cover;
                border-radius: 8px 8px 0 0;
                // overflow: hidden;
              }
              .text {
                // overflow: hidden;
                font-size: 13px;
                padding: 6px;
                background: #ffffff;
                border-radius: 0 0 6px 6px;
                border: 1px solid #e9e9e9;
                border-top: 0;
                p:nth-child(1) {
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 500;
                  font-size: 13px;
                  color: #333333;
                  line-height: 18px;
                  text-align: justify;
                  font-style: normal;
                }
                p:nth-child(2) {
                  display: flex;
                  justify-content: space-between;
                  margin-top: 8px;
                  font-size: 9px;
                  span {
                    font-family: PingFangSC, PingFang SC;
                    font-size: 12px;
                    font-weight: 500;
                    color: #fe3134;
                    line-height: 13px;
                    text-align: left;
                    font-style: normal;
                    font {
                      font-size: 9px;
                      font-weight: 400;
                    }
                  }
                  del {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 9px;
                    color: #999999;
                    line-height: 13px;
                    text-align: right;
                    font-style: normal;
                  }
                }
              }
            }
          }
          .more {
            width: 268px;
            height: 43px;
            background: url('./images/查看更多.png');
            background-size: 100% 100%;
            margin: 6px auto 0;
          }
        }
      }

      .activity {
        margin-top: 14px;
        background: url('./images/乐享年时.png');
        background-size: 100% 100%;
        height: 264px;
        box-sizing: border-box;
        padding: 45px 18px 18px;
        .sec {
          height: 96px;
          padding: 12px;
          box-sizing: border-box;
          .title {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #333333;
            line-height: 22px;
            text-align: left;
            font-style: normal;
          }
          .desc {
            margin-top: 2px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #8c8c8c;
            line-height: 17px;
            text-align: justify;
            font-style: normal;
          }
          .btn {
            margin-top: 6px;
            width: 64px;
            height: 21px;
            background: linear-gradient(137deg, #ff8686 0%, #ff4646 100%);
            border-radius: 11px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #fff6f1;
            line-height: 21px;
            text-align: center;
            font-style: normal;
          }
          &.sec1 {
            background: url('./images/开好运.png');
            background-size: 100% 100%;
            margin-bottom: 10px;
          }
          &.sec2 {
            background: url('./images/去抽奖.png');
            background-size: 100% 100%;
          }
        }
      }

      .hd {
        width: 375px;
        height: 88px;
        margin-left: -12px;
      }

      .strategy {
        margin-top: -2px;
        position: relative;
        height: 670px;
        background: url('./images/蒙版.png');
        background-size: 100% 100%;
        position: relative;
        padding: 15px 10px;
        box-sizing: border-box;

        .map {
          object-fit: cover;
          vertical-align: middle;
          width: 335px;
          height: 455px;
          margin-bottom: 20px;
        }
        .thing {
          margin-bottom: 12px;
          .label {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #333333;
            line-height: 22px;
            text-align: left;
            font-style: normal;
          }
          .value {
            margin-top: 4px;
            display: flex;
            align-items: center;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #8c2c09;
            line-height: 20px;
            text-align: left;
            font-style: normal;
            img {
              width: 16px;
              height: 16px;
              margin-right: 4px;
            }
          }
        }
        .go {
          display: block;
          margin: 10px auto 0;
          width: 319px;
          height: 42px;
        }
      }

      .waterfall {
        margin-top: 12px;

        .title {
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 18px;
          color: #ffffff;
          line-height: 25px;
          font-style: normal;
          margin-bottom: 16px;
          text-align: center;
          img {
            width: 30px;
            height: 8px;
          }
          div {
            margin: 0 8px;
          }
        }

        .list {
          .item {
            background: #ffffff;
            border-radius: 8px;
            overflow: hidden;

            .cover {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }

            .content {
              padding: 8px;

              .name {
                font-size: 14px;
                font-weight: var(--bold-value);
                color: #333333;
                line-height: 20px;
                display: -webkit-box;
                overflow: hidden;
                text-overflow: ellipsis;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }

              .tags {
                --gap: 8px;
                --margin-top: 8px;
                display: flex;
                flex-wrap: wrap;
                margin-top: calc(var(--gap) - var(--margin-top));

                .tag {
                  margin-top: var(--gap);
                  margin-right: var(--gap);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  background: #fff4e6;
                  color: #ff960a;
                  padding: 3px 6px;
                  border-radius: 4px;
                  font-size: 12px;
                  line-height: 17px;
                }
              }

              .extra {
                margin-top: 8px;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .price {
                  font-size: 18px;
                  font-weight: var(--bold-value);
                  color: #ff3b30;
                  line-height: 25px;

                  span {
                    font-size: 12px;
                    font-weight: normal;
                    color: #ff3b30;
                    line-height: 17px;
                  }
                }

                .sales {
                  font-size: 12px;
                  color: #b4b4b4;
                  line-height: 17px;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
